import { render } from "./JournalList.vue?vue&type=template&id=21653196&scoped=true"
import script from "./JournalList.vue?vue&type=script&lang=js"
export * from "./JournalList.vue?vue&type=script&lang=js"

import "./JournalList.vue?vue&type=style&index=0&id=21653196&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21653196"]])

export default __exports__